(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-wisdom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let resizeTimer;

    function initAboutWisdom(sectionRoot) {
      if (!sectionRoot) return;
      const slider = sectionRoot.querySelector('.about-wisdom__slider');
      if (!slider) return;

      const onMobile = window.innerWidth <= 767;
      const existingInstance = slider.swiper;

      if (!onMobile && existingInstance) {
        existingInstance.destroy(true, true);
        return;
      }

      if (typeof Swiper === 'undefined') return;

      if (onMobile && !existingInstance) {
        new Swiper(slider, {
          slidesPerView: 1.5,
          centeredSlides: true,
          loop: true,
          spaceBetween: 12,
          pagination: {
            el: slider.querySelector('.about-wisdom__pagination'),
            clickable: true
          },
          breakpoints: {
            480: {
              spaceBetween: 14
            }
          }
        });
      }
    }

    function initAllAboutWisdom() {
      document.querySelectorAll('.about-wisdom').forEach(function (sectionRoot) {
        initAboutWisdom(sectionRoot);
      });
    }

    document.addEventListener('DOMContentLoaded', initAllAboutWisdom);
    window.addEventListener('load', initAllAboutWisdom);
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initAllAboutWisdom, 150);
    });
    document.addEventListener('shopify:section:load', function (event) {
      initAboutWisdom(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('[data-article-page]');
    if (!root) return;

    const title = root.getAttribute('data-share-title') || document.title;
    const url = root.getAttribute('data-share-url') || window.location.href;
    const live = document.querySelector('[data-article-share-live]');
    const copiedMsg = root.getAttribute('data-share-copy-msg') || 'Link copied';

    root.querySelectorAll('[data-article-share]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        try {
          if (navigator.share) {
            await navigator.share({ title: title, url: url });
            return;
          }
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
        try {
          await navigator.clipboard.writeText(url);
          if (live) {
            live.textContent = copiedMsg;
            setTimeout(function () {
              live.textContent = '';
            }, 2500);
          }
        } catch (err) {
          window.prompt('Copy link:', url);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const initialSection = document.querySelector('[data-cart-section]');
    if (!initialSection) return;
    const sectionId = initialSection.getAttribute('data-cart-section-id');

    async function refreshCartSection() {
      const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
      const html = await response.text();
      const nextContainer = document.createElement('div');
      nextContainer.innerHTML = html;

      const nextSection = nextContainer.querySelector('[data-cart-section]');
      const currentSection = document.querySelector('[data-cart-section]');
      if (!currentSection) return;

      if (nextSection) {
        currentSection.replaceWith(nextSection);
      } else {
        // Fallback if section_id response returns direct section markup.
        currentSection.outerHTML = html;
      }

      bindCartEvents();
    }

    function setBusyState(element, isBusy) {
      if (!element) return;
      element.disabled = isBusy;
      element.style.pointerEvents = isBusy ? 'none' : '';
      element.style.opacity = isBusy ? '0.6' : '';
    }

    function bindCartEvents() {
      const section = document.querySelector('[data-cart-section]');
      if (!section) return;

      section.querySelector('[data-cart-clear]')?.addEventListener('click', async (e) => {
        e.preventDefault();
        const trigger = e.currentTarget;
        setBusyState(trigger, true);
        try {
          await fetch('/cart/clear.js', { method: 'POST' });
          await refreshCartSection();
        } finally {
          setBusyState(trigger, false);
        }
      });

      section.querySelectorAll('[data-cart-change-qty]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const lineKey = btn.getAttribute('data-cart-line-key');
          const delta = parseInt(btn.getAttribute('data-cart-change-delta') || '0', 10);
          if (!lineKey) return;

          const lineEl = section.querySelector(`[data-cart-line-key="${lineKey}"]`);
          const qtyValueEl = lineEl?.querySelector('.qty-value');
          const currentQty = qtyValueEl ? parseInt(qtyValueEl.textContent || '0', 10) : 0;
          const nextQty = delta === 0 ? 0 : currentQty + delta;

          setBusyState(btn, true);
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: nextQty })
            });
            await refreshCartSection();
          } finally {
            setBusyState(btn, false);
          }
        });
      });

      section.querySelector('[data-cart-apply-discount]')?.addEventListener('click', async (e) => {
        const input = section.querySelector('[data-cart-coupon-code]');
        const code = (input?.value || '').trim();
        if (!code) return;

        const trigger = e.currentTarget;
        setBusyState(trigger, true);
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code })
          });
          await refreshCartSection();
        } finally {
          setBusyState(trigger, false);
        }
      });

      section.querySelector('[data-cart-remove-discount]')?.addEventListener('click', async (e) => {
        const trigger = e.currentTarget;
        setBusyState(trigger, true);
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
          await refreshCartSection();
        } finally {
          setBusyState(trigger, false);
        }
      });
    }

    bindCartEvents();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
  
    const items = document.querySelectorAll('.faq-item');
  
    items.forEach(item => {
      const button = item.querySelector('.faq-question');
  
      button.addEventListener('click', () => {
  
        const isOpen = item.classList.contains('is-open');
  
        items.forEach(i => {
          i.classList.remove('is-open');
          i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        });
  
        if (!isOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
  
      });
  
    });
  
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile Menu
    const dialog = document.querySelector('.mobile-menu');
    const openBtn = document.querySelector('.mobile-toggle');
    const closeBtn = document.querySelector('.mobile-close');

    openBtn?.addEventListener('click', () => dialog.showModal());
    closeBtn?.addEventListener('click', () => dialog.close());

    // Ajax Cart Counter
    const cartCount = document.querySelector('.cart-count');

    function updateCartCount() {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((data) => {
          if (data.item_count > 0) {
            cartCount.textContent = data.item_count;
            cartCount.hidden = false;
          } else {
            cartCount.hidden = true;
          }
        });
    }

    document.addEventListener('submit', function (e) {
      if (e.target.matches('form[action^="/cart/add"]')) {
        e.preventDefault();
        const formData = new FormData(e.target);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        }).then(() => updateCartCount());
      }
    });

    // Listen for custom cart refresh events from sections (e.g. AJAX add-to-cart)
    document.addEventListener('cart:refresh', updateCartCount);

    updateCartCount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-features-benefits"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
  
    let featuresSwiper;
  
    function initFeaturesSwiper() {
      if (window.innerWidth < 1170 && !featuresSwiper) {
        featuresSwiper = new Swiper('.features-wrapper', {
          // Let the CSS set the card width/height; Swiper just scrolls them
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: false,
          spaceBetween: 12,
          pagination: {
            el: '.features-pagination',
            clickable: true,
          },
          breakpoints: {
            768: {
              spaceBetween: 16,
            },
          },
        });
      } else if (window.innerWidth >= 1170 && featuresSwiper) {
        featuresSwiper.destroy(true, true);
        featuresSwiper = undefined;
      }
    }
  
    initFeaturesSwiper();
    window.addEventListener('resize', initFeaturesSwiper);
  
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.hero-slider');
    if (!root) return;

    var slides = root.querySelectorAll('.hero-slide');
    if (!slides.length) return;

    var current = 0;
    var intervalMs = 10000;
    var timerId = null;

    function syncVideos(activeIndex) {
      slides.forEach(function (slide, i) {
        slide.querySelectorAll('video').forEach(function (video) {
          if (i === activeIndex) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });
    }

    function showSlide(index) {
      if (index === current) return;
      slides[current].classList.remove('hero-slide--active');
      current = index;
      slides[current].classList.add('hero-slide--active');
      syncVideos(current);
    }

    syncVideos(0);

    if (slides.length > 1) {
      function schedule() {
        timerId = window.setInterval(function () {
          var next = (current + 1) % slides.length;
          showSlide(next);
        }, intervalMs);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (timerId) window.clearInterval(timerId);
          timerId = null;
          slides.forEach(function (slide) {
            slide.querySelectorAll('video').forEach(function (v) {
              v.pause();
            });
          });
        } else {
          syncVideos(current);
          if (!timerId) schedule();
        }
      });

      schedule();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ingredients-marquee"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initIngredientsMarquee(section) {
    if (!section) return;

    let speed = parseInt(section.dataset.speed) || 8000;
    // Clamp speed between 2000 and 20000ms
    speed = Math.max(2000, Math.min(20000, speed));

    // Row 1: Top (moves left)
    const topSwiperEl = section.querySelector('.js-ingredients-swiper-top');
    if (topSwiperEl && !topSwiperEl.swiper) {
      const topSwiper = new Swiper(topSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: true,
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: false,
        speed: speed,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: false
        },
        breakpoints: {
          768: {
            spaceBetween: 60
          }
        },
        on: {
          init: function() {
            // Ensure linear timing
            this.wrapperEl.style.transitionTimingFunction = 'linear';
          }
        }
      });

      // Note: hover pause is disabled to avoid any stutter when resuming
    }

    // Row 2: Bottom (same behavior as top)
    const bottomSwiperEl = section.querySelector('.js-ingredients-swiper-bottom');
    if (bottomSwiperEl && !bottomSwiperEl.swiper) {
      const bottomSwiper = new Swiper(bottomSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: true,
        freeMode: false,
        freeModeMomentum: false,
        allowTouchMove: false,
        speed: speed,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true
        },
        breakpoints: {
          768: {
            spaceBetween: 60
          }
        },
        on: {
          init: function() {
            // Ensure linear timing
            this.wrapperEl.style.transitionTimingFunction = 'linear';
          }
        }
      });

      // Note: hover pause is disabled to avoid any stutter when resuming
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ingredients-swiper').forEach(function(section) {
      initIngredientsMarquee(section);
    });
  });

  // Initialize on Shopify section load
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.target.querySelector('.ingredients-swiper') || 
                    (e.target.classList.contains('ingredients-swiper') ? e.target : null);
    if (section) {
      initIngredientsMarquee(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-showcase-centered"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductShowcase(section) {
      if (!section) return;

      const grid = section.querySelector('.product-showcase__grid');
      if (!grid) return;

      const cards = grid.querySelectorAll('.product-card-wrapper');
      const thumbs = section.querySelectorAll('.product-showcase__thumb');

      function updateMobileActiveCardBackground(index) {
        if (window.innerWidth > 1199) return;
        const cardWrapper = cards[index];
        if (!cardWrapper) return;
        const inactiveBg = cardWrapper.getAttribute('data-inactive-bg');
        const activeCard = cardWrapper.querySelector('.product-card--active');
        if (inactiveBg && activeCard) {
          activeCard.style.backgroundImage = 'url(' + inactiveBg + ')';
          activeCard.style.backgroundSize = 'cover';
          activeCard.style.backgroundPosition = 'center';
          activeCard.style.backgroundRepeat = 'no-repeat';
        }
      }

      function removeActive() {
        cards.forEach(function (card) {
          card.classList.remove('product-card-wrapper--active');
        });
        thumbs.forEach(function (thumb) {
          thumb.classList.remove('product-showcase__thumb--active');
        });
      }

      function setActive(index) {
        removeActive();
        if (cards[index]) {
          cards[index].classList.add('product-card-wrapper--active');
        }
        if (thumbs[index]) {
          thumbs[index].classList.add('product-showcase__thumb--active');
        }
        updateMobileActiveCardBackground(index);
      }

      // Desktop: change active card on hover
      if (window.matchMedia('(hover: hover)').matches) {
        cards.forEach(function (card, index) {
          card.addEventListener('mouseenter', function () {
            setActive(index);
          });
        });
      }

      // Click/tap: select the card when it is not the active one, and open the
      // product page when it already is. Until now clicking a card did nothing
      // but re-select it, so ADD TO CART was the only way off the card.
      // Clicks on a button, link or form keep their own behaviour, and EXPLORE
      // stays the keyboard route to the same page.
      cards.forEach(function (card, index) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('a, button, form')) {
            return;
          }
          if (!card.classList.contains('product-card-wrapper--active')) {
            setActive(index);
            return;
          }
          var href = card.getAttribute('data-product-url');
          if (href) {
            window.location.href = href;
          }
        });
      });

      // Thumb click (mobile + desktop): switch active product
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          setActive(index);
        });
      });

      // Set initial mobile background for the active card
      var initialIndex = 0;
      cards.forEach(function (card, index) {
        if (card.classList.contains('product-card-wrapper--active')) {
          initialIndex = index;
        }
      });
      updateMobileActiveCardBackground(initialIndex);
    }

    // Initialize on DOM ready
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.product-showcase').forEach(function (section) {
        initProductShowcase(section);
      });
    });

    // Initialize on Shopify section load
    document.addEventListener('shopify:section:load', function (e) {
      const section =
        e.target.querySelector('.product-showcase') ||
        (e.target.classList.contains('product-showcase') ? e.target : null);
      if (section) {
        initProductShowcase(section);
      }
    });

    // AJAX Cart
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ajax-add-to-cart').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          const formData = new FormData(this);

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          })
            .then(function (response) {
              if (!response.ok) {
                return;
              }
              // Trigger cart update event (for any global listeners)
              document.dispatchEvent(new Event('cart:refresh'));
              // Simple UX: go to cart so the user clearly sees the item added
              window.location.href = '/cart';
            })
            .catch(function (error) {
              console.error('Add to cart failed', error);
            });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.video-reviews');
    if (!section) return;

    var allVideos = section.querySelectorAll('video.review-video');
    var allCards = section.querySelectorAll('.video-card');

    function pauseAllVideosExcept(exceptVideo) {
      allVideos.forEach(function (v) {
        if (v !== exceptVideo) {
          v.pause();
          v.currentTime = 0;
        }
      });
      allCards.forEach(function (card) {
        var btn = card.querySelector('.video-card__btn--play');
        if (btn) {
          var cardVideo = card.querySelector('video');
          btn.classList.toggle('is-playing', cardVideo && !cardVideo.paused);
        }
      });
    }

    function updatePlayButtonState(btn, video) {
      if (!btn || !video) return;
      btn.classList.toggle('is-playing', !video.paused);
    }

    function updateMuteButtonState(btn, video) {
      if (!btn || !video) return;
      btn.classList.toggle('is-muted', video.muted);
      btn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    }

    allCards.forEach(function (card) {
      var video = card.querySelector('video.review-video');
      var btnPlay = card.querySelector('.video-card__btn--play');
      var btnMute = card.querySelector('.video-card__btn--mute');
      if (!video || !btnPlay || !btnMute) return;

      updateMuteButtonState(btnMute, video);

      video.addEventListener('play', function () {
        updatePlayButtonState(btnPlay, video);
        pauseAllVideosExcept(video);
      });
      video.addEventListener('pause', function () {
        updatePlayButtonState(btnPlay, video);
      });

      btnPlay.addEventListener('click', function () {
        if (video.paused) {
          pauseAllVideosExcept(video);
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      btnMute.addEventListener('click', function () {
        video.muted = !video.muted;
        updateMuteButtonState(btnMute, video);
      });
    });

    var swiperEl = section.querySelector('.videoReviewsSwiper');
    if (swiperEl) {
      var swiper = new Swiper(swiperEl, {
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 40,
        loop: true,
        pagination: {
          el: '.video-reviews-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.video-reviews-nav--next',
          prevEl: '.video-reviews-nav--prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
          },
        },
        on: {
          init: function () {
            pauseAllVideosExcept(null);
          },
          slideChangeTransitionStart: function () {
            pauseAllVideosExcept(null);
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-legal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-legal-page]');
    if (!root) return;
    var filterRoot = root.querySelector('[data-legal-filter-root]');
    if (!filterRoot) return;

    var trigger = filterRoot.querySelector('[data-legal-filter-trigger]');
    var menu = filterRoot.querySelector('[data-legal-filter-menu]');
    var options = filterRoot.querySelectorAll('[data-legal-filter-option]');
    if (!trigger || !menu || !options.length) return;

    function closeMenu() {
      filterRoot.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      var isOpen = filterRoot.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(isOpen));
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var url = option.getAttribute('data-url');
        if (!url) return;
        window.location.href = url;
      });
    });

    document.addEventListener('click', function (event) {
      if (!filterRoot.contains(event.target)) closeMenu();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-disclaimer-tabs"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
  
    const section = document.querySelector('.product-tabs');
    if (!section) return;
  
    const tabs = section.querySelectorAll('.product-tabs__tab');
    const panels = section.querySelectorAll('.product-tabs__panel');
  
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
  
        const target = this.getAttribute('aria-controls');
  
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
  
        panels.forEach(panel => {
          panel.classList.remove('is-active');
        });
  
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        section.querySelector('#' + target).classList.add('is-active');
  
      });
    });
  
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-element"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function () {
    var swiperEl = document.querySelector('.product-element__swiper');
    if (
      swiperEl &&
      swiperEl.dataset &&
      swiperEl.dataset.mediaMode === 'slider_all' &&
      typeof Swiper !== 'undefined'
    ) {
      var prevEl = swiperEl.querySelector('.product-element__arrow--prev');
      var nextEl = swiperEl.querySelector('.product-element__arrow--next');

      if (!prevEl || !nextEl) return;

      new Swiper(swiperEl, {
        loop: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        }
      });
    }
  
    const button = document.querySelector('.product-element__cta button');
  
    if (button) {
      button.addEventListener('click', function() {
  
        const variantId = this.dataset.variantId;
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(res => res.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
  
      });
    }

  
  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
  
    const heroSection = document.querySelector('.product-hero');
    if (!heroSection) return;

    const buy = heroSection.querySelector('.product-hero__buy');
    const ctaButton = heroSection.querySelector('.product-hero__add');
    const qtyInput = heroSection.querySelector('[data-qty-input]');
    const totalEl = heroSection.querySelector('[data-price-total]');
    const unitCents = buy ? parseInt(buy.dataset.unitCents, 10) : 0;

    function clampQty(v) {
      v = parseInt(v, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > 20) v = 20;
      return v;
    }
    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function syncTotal() {
      if (!qtyInput || !totalEl) return;
      const q = clampQty(qtyInput.value);
      qtyInput.value = q;
      if (q > 1 && unitCents) {
        totalEl.textContent = money(unitCents * q) + ' for ' + q;
        totalEl.hidden = false;
      } else {
        totalEl.hidden = true;
      }
    }

    heroSection.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = clampQty(qtyInput.value) + parseInt(btn.dataset.qtyStep, 10);
        syncTotal();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', syncTotal);

    const toast = heroSection.querySelector('.product-hero__toast');
    let toastTimer;
    function showToast(q) {
      if (!toast || !buy) return;
      const name = buy.dataset.productTitle || 'Item';
      toast.querySelector('[data-toast-text]').textContent =
        (q > 1 ? q + ' × ' + name : name) + ' added to cart';
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.hidden = true; }, 250);
      }, 5000);
    }

    const sticky = document.querySelector('[data-product-sticky]');
    const stickyBtn = sticky ? sticky.querySelector('.product-sticky__add') : null;
    if (sticky) {
      // Position check on every scroll, not an IntersectionObserver: a jump
      // from the top straight past the Add to Cart row (an anchor link, or a
      // long page on a phone) never crosses the viewport edge, so an
      // observer never fires and the bar stayed hidden.
      const ctaRow = heroSection.querySelector('.product-hero__cta') || heroSection;
      let shown = null;
      function updateSticky() {
        const headerH = parseInt(getComputedStyle(document.body).paddingTop, 10) || 0;
        const past = ctaRow.getBoundingClientRect().bottom < headerH;
        if (past === shown) return;
        shown = past;
        sticky.classList.toggle('is-visible', past);
        document.body.classList.toggle('has-product-sticky', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
      }
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    if (ctaButton) {
      const label = ctaButton.innerHTML;
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () { ctaButton.click(); });
      }
      ctaButton.addEventListener('click', function () {
        const q = clampQty(qtyInput ? qtyInput.value : 1);
        ctaButton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.dataset.variantId, quantity: q })
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          ctaButton.textContent = q > 1 ? 'Added ' + q : 'Added';
          showToast(q);
          if (stickyBtn) {
            const stickyLabel = stickyBtn.innerHTML;
            stickyBtn.textContent = (q > 1 ? q + ' × ' : '') + (buy.dataset.productTitle || '') + ' added';
            setTimeout(function () { stickyBtn.innerHTML = stickyLabel; }, 2500);
          }
          setTimeout(function () { ctaButton.innerHTML = label; ctaButton.disabled = false; }, 1600);
        })
        .catch(function (error) {
          console.error('Add to cart failed:', error);
          ctaButton.innerHTML = label;
          ctaButton.disabled = false;
        });
      });
    }

    // Bundle tab: add two of this blend in one step
    document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
      const status = btn.parentNode.querySelector('[data-bundle-status]');
      const label = btn.innerHTML;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(btn.dataset.items
            ? { items: JSON.parse(btn.dataset.items) }
            : { id: btn.dataset.variantId, quantity: 2 })
        })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (status) {
            status.querySelector('[data-bundle-text]').textContent =
              (btn.dataset.bundleName || '2 × ' + ((buy && buy.dataset.productTitle) || 'Item')) + ' added to cart';
            status.hidden = false;
          }
        })
        .catch(function (error) { console.error('Add to cart failed:', error); })
        .finally(function () { btn.innerHTML = label; btn.disabled = false; });
      });
    });

    // How To | Bundle | Ingredients | Shipping | Disclaimer tabs (arrow keys move between tabs)
    document.querySelectorAll('[data-hero-tabs]').forEach(function (wrap) {
      const tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      const bar = wrap.querySelector('[data-product-info-bar]');
      const panels = wrap.querySelector('[data-product-info-panels]');
      const slot = bar ? bar.parentNode : null;
      // The fixed header covers the top of the window; body padding-top is its height.
      const topOffset = function () { return parseInt(getComputedStyle(document.body).paddingTop, 10) || 0; };
      function pin() {
        if (!bar) return;
        const top = topOffset();
        bar.style.setProperty('--product-info-top', top + 'px');
        slot.style.height = bar.offsetHeight + 'px';
        bar.classList.toggle('is-pinned', slot.getBoundingClientRect().top < top);
      }
      if (bar) {
        window.addEventListener('scroll', pin, { passive: true });
        window.addEventListener('resize', pin);
        pin();
      }
      function select(tab) {
        // Phones: the tab row scrolls sideways; keep the chosen tab fully visible.
        const row = tab.parentNode;
        const tr = tab.getBoundingClientRect(), rr = row.getBoundingClientRect();
        if (tr.left < rr.left) row.scrollLeft -= rr.left - tr.left + 16;
        else if (tr.right > rr.right) row.scrollLeft += tr.right - rr.right + 16;
        tabs.forEach(function (t) {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(tab);
          // Pinned: bring the panel into view just under the tab row.
          if (bar && panels && bar.classList.contains('is-pinned')) {
            const y = panels.getBoundingClientRect().top + window.scrollY - topOffset() - bar.offsetHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });
        tab.addEventListener('keydown', function (e) {
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });

  });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-more-supplement"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.ajax-add-to-cart').forEach(function (form) {

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
      .then(function (response) {
        if (!response.ok) return;
        document.dispatchEvent(new Event('cart:refresh'));
        window.location.href = '/cart';
      })
      .catch(function (error) {
        console.error('Add to cart failed', error);
      });

    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
